import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronDown, FiChevronUp } = FiIcons;

const faqData = [
  {
    question: "What exactly is a Gold IRA and how does it work?",
    answer: "A Gold IRA is a self-directed retirement account that allows you to hold physical gold, silver, or other approved precious metals as an investment. It works just like a traditional IRA in terms of tax benefits, but instead of holding paper assets like stocks, you own physical bullion stored in a secure depository."
  },
  {
    question: "How accurate are the projections in this Gold IRA Calculator?",
    answer: "Our calculator uses historical data—averaging roughly 7% for the stock market and 5% for gold over the long term. While it is a powerful tool for visualising 'what if' scenarios and understanding the impact of an inflation hedge, it should be used for educational purposes and not as a guarantee of future returns."
  },
  {
    question: "What are the common fees associated with a Gold IRA?",
    answer: "Typical fees include a one-time setup fee (usually $50-$150), an annual administrative fee from the custodian ($80-$150), and an annual storage fee for the depository ($100-$200). Some premium companies like Augusta Precious Metals may waive these fees for the first few years depending on your investment size."
  },
  {
    question: "Is a Gold IRA rollover a taxable event?",
    answer: "No. If performed correctly via a 'direct rollover' or 'trustee-to-trustee transfer,' the funds move from your current 401(k) or IRA directly to your new Gold IRA custodian. There are no taxes or penalties triggered by this process."
  },
  {
    question: "Why should I use a Gold IRA as an inflation hedge?",
    answer: "Gold has historically maintained its purchasing power as the value of the dollar declines. When the cost of goods and services rises, gold prices typically trend upward, helping to preserve the real value of your retirement savings when paper assets might be stagnant."
  },
  {
    question: "Can I take physical possession of the gold?",
    answer: "You can take physical possession once you reach age 59.5 as a 'distribution.' However, while the gold is in the IRA, it must be held by a qualified third-party depository. Taking it home before retirement age is considered a withdrawal and is subject to taxes and penalties."
  },
  {
    question: "What is the minimum investment for a Gold IRA?",
    answer: "While there is no legal minimum set by the IRS, most reputable gold IRA companies require a minimum of $25,000 to $50,000 to ensure the annual fees don't disproportionately eat into your investment returns."
  },
  {
    question: "Which is better: Gold or Silver for my IRA?",
    answer: "Both have advantages. Gold is traditionally less volatile and acts as a pure wealth preservation tool. Silver is more volatile but has significant industrial demand, which can lead to higher percentage gains during economic expansions."
  },
  {
    question: "How long does the rollover process take?",
    answer: "The process typically takes between 2 to 4 weeks. This includes setting up the new SDIRA, transferring the funds from your old custodian, and purchasing the actual metals."
  },
  {
    question: "Is physical gold better than a Gold ETF?",
    answer: "A Gold ETF is a paper contract representing gold, which carries 'counterparty risk.' If the financial system fails, the ETF may not be redeemable for the actual metal. Physical gold in an IRA is tangible property that you own directly, providing higher security."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">Gold IRA Calculator: Common Questions</h2>
          <p className="text-slate-600">Everything you need to know about diversifying your retirement with precious metals.</p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div 
              key={index} 
              className={`border rounded-lg transition-all duration-300 ${openIndex === index ? 'border-yellow-400 bg-yellow-50/30' : 'border-slate-200 hover:border-slate-300'}`}
            >
              <button
                className="w-full px-6 py-5 flex justify-between items-center focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                <span className="font-bold text-left text-slate-900 pr-8">{faq.question}</span>
                <SafeIcon 
                  icon={openIndex === index ? FiChevronUp : FiChevronDown} 
                  className={`text-xl flex-shrink-0 transition-transform ${openIndex === index ? 'text-yellow-600 rotate-180' : 'text-slate-400'}`}
                />
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6 text-slate-600 animate-fadeIn">
                  <p className="leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;